@use "../../styles/breakpoint.module.scss" as *;

.item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--spacer-24);
    padding-bottom: var(--spacer-24);
    border-bottom: 1px solid var(--gray-300);

    @media ($below-mobile) {
        flex-direction: column;
        gap: var(--spacer-16);
    }
}

.content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-12);
}

.title {
    font: var(--font-h-24-lg);
    text-decoration: none;
    color: inherit;

    @media ($below-mobile) {
        font: var(--font-h-24-sm);
    }
}

.eyebrow {
    font: var(--font-eyebrow-12-lg);
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

.button {
    flex-shrink: 0;
}
